import * as React from "react";
//imports from react library
import { useEffect } from "react";
//imported from  mui library
import { yupResolver } from "@hookform/resolvers/yup";
import { Checkbox, TextField } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import DropdownField from "../../../../common/components/FormFields/DropdownField";
import InputField from "../../../../common/components/FormFields/InputField";
import {
  errorAlert,
  successAlert,
} from "../../../../common/components/Toasts/CustomToasts";
import {
  getListOfOPDPedingBills,
  ipdCompanySettlementPdfPrint,
  saveCompanyBillSettlement,
} from "../../../../ipd/services/billSettlement/IPDCompanySettlementServices";
import { patientAdvanceBalance } from "../../../../ipd/services/billSettlement/IPDSelfBillSettlementServices";
import PreviousCompSettlementModal from "./PreviousCompSettlementModal";

import ApplyButton from "../../../../common/components/Buttons/ApplyButton";

import { fetchCompany } from "../../../../commonServices/miscellaneousServices/MiscServices";

import { useLocation } from "react-router-dom";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import CommonBackDrop from "../../../../common/components/CommonBackDrop/CommonBackDrop";
import CommonDynamicTableNew from "../../../../common/components/CommonTable/CommonDynamicTableNew";
import CheckBoxField from "../../../../common/components/FormFields/CheckBoxField";
import CommonPrintModal from "../../../../common/components/printModal/CommonPrintModal";
import { fetchUserActionsByMenuId } from "../../../../commonServices/functionalityServices/FunctionalityServices";
import BillInformtionModal from "./BillInformtionModal";

const Actions = [
  {
    id: 0,
    action: "print",
    isAction: true,
  },
  {
    id: 1,
    action: "view",
    isAction: false,
  },
  {
    id: 2,
    action: "settleBill",
    isAction: false,
  },
];
const ipdOpdObj = [
  {
    id: "OPD",
    value: "OPD",
    label: "OPD",
  },
];
export default function CompanySettlement() {
  const schema = yup
    .object()
    .typeError("Please Select Company")
    .shape({
      company: yup
        .object()
        .shape({
          label: yup.string().required("Please Select Company"),
          value: yup.string().required("Please Select Company"),
        })
        .required("Please Select Company"),
      tdsAmount: yup.number().required(),
    });
  const defaultValues = {
    totalAmount: 0,
    tdsAmount: 0,
    netAmount: 0,
    company: null,
  };
  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
    defaultValues,
  });
  const {
    watch,
    register,
    handleSubmit,
    reset,
    getValues,

    formState: { errors, isValid },
    control,
    setValue,
    clearErrors,
    setError,
  } = methods;

  //state varibales

  const [data, setData] = React.useState();
  const [openChild, setOpenChild] = React.useState(false);
  const [company, setCompany] = React.useState(null);
  const [openPreviourReceipt, setOpenPreviourReceipt] = React.useState(false);
  const [selectedToDate, setSelectedToDate] = React.useState(new Date());
  const [selectedFromDate, setSelectedFromDate] = React.useState(new Date());
  const [openBackdrop, setOpenBackdrop] = React.useState(false);
  const [tdsAmt, setTdsAmt] = React.useState(0);
  const [selectedBillArray, setSelectedBillArray] = React.useState([]);
  const [selectedRow, setSelectedRow] = React.useState([]);
  const [amount, setAmount] = React.useState(0);
  const [netAmount, setNetAmount] = React.useState(0);
  const [netBillAmount, setNetBillAmount] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [rowData, setRowData] = React.useState();
  const [advanceBalance, setAdvanceBalance] = React.useState("");
  const [userActions, setUserActions] = React.useState([]);
  const [menuIdVal, setMenuIdVal] = React.useState(null);
  const [urlforPrint, setUrlforPrint] = React.useState();
  const [openPrintModal, setOpenPrintModal] = React.useState(false);
  const [paymentInfo, setPaymentInfo] = React.useState({
    paymentInfoList: [],
    advanceConsumeList: [],
  });
  const [billAdvanceDetailsList, setBillAdvanceDetailsList] = React.useState(
    [],
  );
  const [totalConsumeAmount, setTotalConsumeAmount] = React.useState(0);
  //function to open the confirmation modal
  const handleOpenChild = () => setOpen(true);
  const handleCloseChild = () => setOpen(false);
  const handleOpenReceipt = () => setOpenPreviourReceipt(true);
  const handleCloseReceipt = () => setOpenPreviourReceipt(false);
  //other variablelet
  let ipdOpdValue = watch("ipdOpdObj");
  let companyDropDownValue = watch("company");
  let netAmountVal = watch("netAmount");
  let tdsAmountVal = watch("tdsAmount");

  // get menu id
  let location = useLocation();

  // button and menu id
  useEffect(() => {
    location?.state?.menuId &&
      fetchUserActionsByMenuId(location?.state?.menuId)
        .then((response) => response.data)
        .then((res) => {
          setUserActions(res.result);
        });
  }, []);

  //useEffects
  useEffect(() => {
    fetchCompany()
      .then((response) => response.data)
      .then((res) => {
        setCompany(res.result);
      });
    setValue("company", null);
  }, []);

  // set amount to field
  useEffect(() => {
    setValue("totalAmount", amount.toFixed(2));
    setValue("netAmount", amount.toFixed(2));
    setNetAmount(amount);
  }, [amount]);

  useEffect(() => {
    let amt = 0;
    // let tempArr=selectedRow
  }, [selectedRow, errors]);

  React.useEffect(() => {
    if (companyDropDownValue !== null) {
      fethCompanyList();
    }
  }, [companyDropDownValue, selectedFromDate, selectedToDate]);

  // company peding list api call fun
  function fethCompanyList() {
    let compPostObj = {
      companyId: companyDropDownValue ? companyDropDownValue.id : null,
      opdIpd: 1,
      fromDate: selectedFromDate,
      toDate: selectedToDate,
    };

    getListOfOPDPedingBills(compPostObj)
      .then((response) => response.data)
      .then((res) => {
        setData(
          res.result?.map((val) => ({
            ...val,
            isChecked: false,
          })),
        );
      });
  }

  // get table row data information

  function displayRowData(e, row) {
    let amt = row["Balance Amount Non Self"];
    let netBillAmt = row["Net Bill Amount"];
    if (e === true) {
      setAmount(amount + Number(amt));
      setNetBillAmount(netBillAmount + Number(netBillAmt));
    } else if (e === false) {
      setAmount(amount - Number(amt));
      setNetBillAmount(netBillAmount - Number(netBillAmt));
    }
  }

  // get patient advance
  function getPatientAdvance(PatientId) {
    patientAdvanceBalance(PatientId)
      .then((response) => response.data)
      .then((res) => {
        setAdvanceBalance(res.result.PatientAdvance);
      });
  }

  // calculate tds and set tds amount
  function tdsCalculation(e) {
    console.log("eeeeeeeeeeee", e?.target?.value);
    if (e?.target?.value !== "" && e?.target?.value <= amount) {
      setTdsAmt(Number(e?.target?.value));
    } else if (e?.target?.value === "") {
      setTdsAmt(0);
      setValue("tdsAmount", 0);
      setValue("netAmount", amount?.toFixed(2));
      setNetAmount(amount);
    }
  }

  function getNetAmount() {
    setValue("netAmount", amount - tdsAmt);
    setNetAmount(amount - tdsAmt);
  }

  console.log("tdsAmt", tdsAmt, "amount", amount);

  // on submit data handler
  function submitPaymentInfoModal(paymentInfo) {
    let userInfoString = localStorage.getItem("userInfo");
    let userInfoObj = JSON.parse(userInfoString);

    let tds = getValues("tdsAmount");

    let companyPostObj = {
      addedBy: userInfoObj.userId,
      balanceBill: selectedRow["Balance Amount Non Self"],
      billId: selectedBillArray?.map((val) => val?.BillId),
      cashCounterId: userInfoObj.cashCounterId,
      isCash: true,
      opdIpd: 1,
      opdIpdExternalId: selectedRow["Opd_Ipd_External_Id"],
      paidAmount: 0,
      paymentId: 0,
      paymentType: 0,
      menuId: location?.state?.menuId,
      privilege: menuIdVal?.action,
      totalAmt: netBillAmount,
      //totalBill: selectedRow["Total Bill Amount"],
      tdsPerAmount: Number(tds),
      netBillAmount: Number(netAmountVal),
    };
    companyPostObj.paymentInfoList = paymentInfo?.paymentInfoList;
    companyPostObj.advanceConsumeDtoList = paymentInfo?.advanceConsumeList;
    setOpenBackdrop(true);
    saveCompanyBillSettlement(companyPostObj)
      .then((response) => response.data)
      .then((res) => {
        successAlert(res.message);
        setOpenBackdrop(false);
        handleOpenPrintModal(res.result);
        setData("");
        setTdsAmt(0);
        setSelectedFromDate(new Date());
        setSelectedToDate(new Date());
        setAmount(0);
        setSelectedBillArray([]);
        setNetBillAmount(0);
        setValue("netAmount", null);
        setNetAmount(0);
        reset(defaultValues);
        handleCloseChild();
        setPaymentInfo({ paymentInfoList: [], advanceConsumeList: [] });
        setBillAdvanceDetailsList([]);
        setTotalConsumeAmount(0);
      })
      .catch((error) => {
        errorAlert(error?.response?.data?.message || error?.message);
        setOpenBackdrop(false);
      });
  }

  const handleClosePrintModal = () => {
    setOpenPrintModal(false);
  };
  const handleOpenPrintModal = (paymentId) => {
    // admissionId,formId
    ipdCompanySettlementPdfPrint(paymentId).then((response) => {
      setUrlforPrint(response);
    });
    setOpenPrintModal(true);
  };

  // print and action mgmt
  const renderActions = (row, index) => {
    return (
      <div className="flex gap-3">
        {/* {userActions &&
          userActions.map((actions, i) => (
            <>
              {actions.isAction === false ? (
                <>
                  <div className="flex gap-2 cursor-pointer">
                    {actions.action === "Print" ? ( */}
        <fieldset className="m-0 p-0">
          <Checkbox
            size="small"
            checked={row?.isChecked}
            name={`selectedOptions${index}`}
            onChange={(e) => {
              let tempArr = [...selectedBillArray];
              let tempData = [...data];
              if (e.target.checked === true) {
                tempData[index].isChecked = true;
                setData(tempData);
                tempArr.push(row);
                setSelectedBillArray(tempArr);
              } else if (e?.target?.checked === false) {
                tempData[index].isChecked = false;
                setData(tempData);
                let filteredArr = tempArr.filter(
                  (item) => item?.BillId !== row?.BillId,
                );
                setSelectedBillArray(filteredArr);
              }
              displayRowData(e?.target?.checked, row);
            }}
          />
        </fieldset>
        {/* ) : null}
                    </div>
                  </>
                ) : null}
              </>
            ))} */}
      </div>
    );
  };
  function handleSelectedRow() {}
  function onSubmitDataHandler(data) {}
  return (
    <>
      <div className="w-full grid mt-16 px-6  md:rounded-md ">
        <div>
          <div className="text-center text-black font-bold text-xl ">
            Company Bill Settlement
          </div>
        </div>
        <div className="py-2 ">
          <form onSubmit={handleSubmit(onSubmitDataHandler)}>
            <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-3">
              <div className="w-full">
                <DropdownField
                  control={control}
                  error={errors.company}
                  name="company"
                  dataArray={company}
                  placeholder="Select Company"
                  isClearable={true}
                  isSearchable={true}
                  searchIcon={true}
                  inputRef={{
                    ...register("company", {
                      onChange: (e) => {
                        setSelectedBillArray([]);
                      },
                    }),
                  }}
                />
              </div>
              <div className="flex space-x-2 w-full">
                <Controller
                  control={control}
                  rules={{
                    required: true,
                  }}
                  render={({ field }) => (
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DesktopDatePicker
                        disableFuture
                        label="From Date"
                        value={selectedFromDate}
                        inputFormat="dd/MM/yyyy"
                        onChange={(newValue) => {
                          setSelectedFromDate(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            className="bg-white"
                            name="fromDateCalender"
                            fullWidth
                            size="small"
                            {...params}
                            sx={{
                              svg: {
                                color: "#1e3a8a",
                                height: 22,
                                width: "100%",
                                marginRight: "16px",
                              },
                              backgroundColor: "white",
                              overflow: "visible",

                              "& .MuiOutlinedInput-root": {
                                "& .MuiOutlinedInput-input": {
                                  // border: 0,
                                  fontSize: 14,
                                  height: "18px",
                                  width: "100%",

                                  borderColor: "#0B83A5",
                                  overflow: "hidden",
                                },
                                "& .MuiFormLabel-root": {
                                  fontSize: "14px",
                                },
                              },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  )}
                  name="fromDateCalender"
                />
                <Controller
                  control={control}
                  rules={{
                    required: true,
                  }}
                  render={({ field }) => (
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DesktopDatePicker
                        disableFuture
                        label="To Date"
                        value={selectedToDate}
                        inputFormat="dd/MM/yyyy"
                        onChange={(newValue) => {
                          setSelectedToDate(newValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            className="bg-white"
                            name="toDateCalender"
                            fullWidth
                            size="small"
                            {...params}
                            sx={{
                              svg: {
                                color: "#1e3a8a",
                                height: 22,
                                width: "100%",
                                marginRight: "16px",
                              },
                              backgroundColor: "white",
                              overflow: "visible",

                              "& .MuiOutlinedInput-root": {
                                "& .MuiOutlinedInput-input": {
                                  // border: 0,
                                  fontSize: 14,
                                  height: "18px",
                                  width: "100%",

                                  borderColor: "#0B83A5",
                                  overflow: "hidden",
                                },
                                "& .MuiFormLabel-root": {
                                  fontSize: "14px",
                                },
                              },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  )}
                  name="toDateCalender"
                />
              </div>
              <div className="flex justify-between col-span-2 lg:col-span-1 xl:col-span-2 2xl:col-span-3">
                <CommonButton
                  searchIcon={true}
                  className="bg-customBlue text-white"
                  onClick={() => {
                    fethCompanyList();
                  }}
                />
                <div className="">
                  {userActions &&
                    userActions.map((obj) => (
                      <>
                        {!obj.isAction && obj.action === "View" ? (
                          <CommonButton
                            label="View"
                            className="bg-[#1e3a8a] text-white "
                            onClick={() => {
                              handleOpenReceipt();
                            }}
                          />
                        ) : null}
                      </>
                    ))}
                </div>
              </div>
            </div>
          </form>
        </div>

        {companyDropDownValue !== null ? (
          <>
            <div className="flex justify-between my-2 items-center">
              <div className="w-full text-base text-black font-semibold">
                List Of Pending Bills
              </div>
            </div>
            {data && data.length > 0 ? (
              <>
                <div className="px-0">
                  <CommonDynamicTableNew
                    dataResult={data}
                    setData={setData}
                    actionsRequired={true}
                    renderActions={renderActions}
                    highlightRow={false}
                    setSelectedRow={setSelectedRow}
                    handleSelectedRow={handleSelectedRow}
                    tableClass={"rounded lg:h-52 md:h-72"}
                    removeHeaders={[
                      "Expr1",
                      "Opd_Ipd_External_Id",
                      "Opd_Ipd_External",
                      "BillId",
                      "PatientId",
                    ]}
                  />
                  {/* <CompanySettlementTable
                    data={data}
                    actions={actions}
                    displayRowData={displayRowData}
                    setSelectedBillArray={setSelectedBillArray}
                    selectedBillArray={selectedBillArray}
                  /> */}
                </div>
              </>
            ) : (
              <>
                <div className="text-center mt-4 p-4">No Record Found</div>
              </>
            )}
            <div className="place-items-end">
              <form onSubmit={handleSubmit(submitPaymentInfoModal)}>
                <div className="flex items-center justify-between">
                  <div className="flex gap-8 mt-2 items-center py-4 md:px-1">
                    <div className="flex gap-3 md:text-sm lg:text-sm items-center">
                      <InputField
                        name="totalAmount"
                        disabled={true}
                        variant="outlined"
                        control={control}
                        label="Total Amount ₹"
                        inputProps={{ style: { textTransform: "capitalize" } }}
                      />
                    </div>

                    {userActions &&
                      userActions.map((obj) => (
                        <>
                          {!obj.isAction && obj.action === "Apply Discount" ? (
                            <>
                              <div className="w-2/12">
                                <InputField
                                  name="tdsAmount"
                                  variant="outlined"
                                  label="T.D.S Amount"
                                  error={errors.tdsAmount}
                                  control={control}
                                  onWheel={(e) => e.target.blur()}
                                  inputRef={{
                                    ...register("tdsAmount", {
                                      onChange: (e) => {
                                        tdsCalculation(e);
                                      },
                                    }),
                                  }}
                                />
                              </div>
                              <div className="">
                                <ApplyButton
                                  onClick={(e) => {
                                    getNetAmount(e);
                                    // setValue("netAmount", tdsAmount);
                                  }}
                                />
                              </div>

                              <div className="w-2/12">
                                <InputField
                                  name="netAmount"
                                  variant="outlined"
                                  label="Net Amount ₹"
                                  error={errors.netamount}
                                  disabled={true}
                                  control={control}
                                  inputProps={{
                                    style: { textTransform: "capitalize" },
                                  }}
                                />
                              </div>
                            </>
                          ) : null}
                        </>
                      ))}
                  </div>
                  <div className="flex justify-end gap-2 md:pt-1">
                    {userActions &&
                      userActions.map((obj) => (
                        <>
                          {!obj.isAction && obj.action === "SettleBill" ? (
                            <div className="w-auto">
                              <CommonButton
                                label="Reset"
                                className="border border-customRed text-customRed"
                                onClick={() => {
                                  reset(defaultValues);
                                  setSelectedFromDate(new Date());
                                  setSelectedToDate(new Date());
                                  setTdsAmt(0);
                                  setAmount(0);

                                  setData(null);
                                }}
                              />
                            </div>
                          ) : null}
                          {!obj.isAction && obj.action === "SettleBill" ? (
                            <div className="whitespace-nowrap">
                              <CommonButton
                                className="bg-blue-900  text-white"
                                label="Settle Bill"
                                onClick={() => {
                                  if (
                                    netAmountVal === null &&
                                    netAmountVal > 0
                                  ) {
                                    errorAlert("Please enter a net amount");
                                  } else if (isValid === false) {
                                    // errorAlert("Please Enter TDS  < 100");
                                  } else if (
                                    netAmountVal !== null &&
                                    netAmountVal > 0 &&
                                    isValid === true
                                  ) {
                                    setOpen(true);

                                    setMenuIdVal(obj);
                                  }
                                }}
                              />
                            </div>
                          ) : null}
                        </>
                      ))}
                  </div>
                </div>
              </form>
              <CommonBackDrop openBackdrop={openBackdrop} />
            </div>
          </>
        ) : (
          ""
        )}
        <BillInformtionModal
          open={open}
          setOpen={setOpen}
          getValues={getValues}
          handleClose={handleCloseChild}
          submitPaymentInfoModal={submitPaymentInfoModal}
          // refundAmount={tdsAmt}
          advanceAmount={advanceBalance}
          rowData={rowData}
          handleCloseChild={handleCloseChild}
          amount={amount}
          setOpenBackdrop={setOpenBackdrop}
          selectedBillArray={selectedBillArray}
          netAmount={netAmount}
          paymentInfo={paymentInfo}
          setPaymentInfo={setPaymentInfo}
          billAdvanceDetailsList={billAdvanceDetailsList}
          setBillAdvanceDetailsList={setBillAdvanceDetailsList}
          totalConsumeAmount={totalConsumeAmount}
          setTotalConsumeAmount={setTotalConsumeAmount}
        />
        <PreviousCompSettlementModal
          openPreviourReceipt={openPreviourReceipt}
          handleCloseReceipt={handleCloseReceipt}
        />
        <ConfirmationModal
          confirmationOpen={openChild}
          confirmationHandleClose={handleCloseChild}
          confirmationSubmitFunc={data}
          confirmationLabel="Confirmation "
          confirmationMsg="Are you sure want to delete this record ?"
          confirmationButtonMsg="Delete"
        />
      </div>
      {openPrintModal ? (
        <CommonPrintModal
          open={openPrintModal}
          setOpen={setOpenPrintModal}
          handleOpen={handleOpenPrintModal}
          handleClose={handleClosePrintModal}
          urlforPrint={urlforPrint}
        />
      ) : null}
    </>
  );
}
